import Header from "../../../components/layout/Header";
import SelectSiteHeader from "../../../components/layout/SelectSiteHeader";
import { useContext, useEffect, useMemo, useState } from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./styles/theme";
import { CustomBoxContents, CustomBoxLiff, CustomBoxContentsLiff } from "./styles/style";
import {
  TabMainMenu,
  CardDataSourceMng,
  DeviceDetails,
  DialogCreateServer,
  DialogSelectServer,
  DialogSyncOneDrive,
  DialogDeviceDetails,
  DialogDialogWarning,
  AlertSnackbar,
  DialogUploadTransaction,
} from "./modules/index";
import DataSourceContext from "./context/DataSourceMngContext";
import DataSourceMngProvider from "./context/DataSourceMngProvider";
import { TabMenuFS } from "./modules/index";
import ESGChart_dashboard from "./ESG/components/index";
import DialogUploadFactSheet from "./modules/modals/factsheet/DialogUploadFactSheet";
import { EditIcon } from "src/components/event_transaction/icons";
import GeneralForm from "./factsheet/GeneralForm";
import ReportCFOForm from "./factsheet/ReportCFOForm";
import { IconButton } from "src/components/ui/baseButton";
import { DatePickerYear } from "src/components/event_transaction/components/shared/Form/DatePicker";
import dayjs from "dayjs";

const DataSourceManagement = () => {

  const queryParams = new URLSearchParams(window.location.search);
  const transaction_id = queryParams.get("id");
  const { tab, mode } = useContext(DataSourceContext);
  return (
    <Box>
      {mode === "liff" ? 
        <Box sx={{ 
          height: "70px",
          position: "relative",
          }}>
          {transaction_id ? 
            <CustomBoxContentsLiff/> :
            <CustomBoxLiff>
              Transactions
            </CustomBoxLiff>
          }
        </Box>
      :(
        <Header pageTitle="Data Source" showSubMenu={false}>
          <SelectSiteHeader />
        </Header>
      )}

      <CustomBoxContents>
        {mode !== "liff" && <TabMainMenu />}
        <ContentsComponent tab={tab} />
      </CustomBoxContents>

      <DialogCreateServer />
      <DialogSelectServer />
      <DialogSyncOneDrive />
      <DialogDeviceDetails />
      <DialogDialogWarning />
      <DialogUploadTransaction />
      <AlertSnackbar />
    </Box>
  );
};

const AllDataSourceManagement = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DataSourceMngProvider>
        <DataSourceManagement />
      </DataSourceMngProvider>
    </ThemeProvider>
  );
};

export default AllDataSourceManagement;

const ContentsComponent = ({ tab }) => {

  const { mode } = useContext(DataSourceContext);
  const [tabFs, setTabFs] = useState("esg");
  const [openDialogUploadFactSheet, setOpenDialogUploadFactSheet] =
    useState(false);
  const [openEditGeneral, setOpenEditGeneral] = useState(false);
  const [openEditCFOReport, setOpenEditCFOReport] = useState(false);
  const [yearDate, setYearDate] = useState(dayjs(new Date()));

  const controlledYearDate = useMemo(() => {
    return {
      yearDate: {
        value: yearDate,
        setValue: setYearDate,
      },
    };
  }, [setYearDate, yearDate]);

  useEffect(() => {
    setOpenEditGeneral(false);
    setOpenEditCFOReport(false);
  }, [tabFs]);

  switch (tab) {
    case "data_source":
      return (
        <Box sx={{ padding: mode !== 'liff' ? "10px 20px" : "0px 10px 10px 10px" }}>
          {mode !== 'liff' && <CardDataSourceMng />}
          <DeviceDetails />
        </Box>
      );
    case "emission_factor":
      return null;
    case "framework":
      return null;
    case "report_template":
      return null;
    case "fact_sheet":
      return (
        <Box sx={{ padding: "10px 20px" }}>
          <div className="flex items-center justify-between pl-10 pr-5">
            <TabMenuFS tab={tabFs} setTab={setTabFs} />

            {(tabFs === "general" || tabFs === "report_cfo") && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* <BaseButton
                  variant="primary"
                  size="small"
                  className="!w-28"
                  onClick={() => setOpenDialogUploadFactSheet(true)}
                >
                  <Text variant="semi-10">Import file(s)</Text>
                </BaseButton> */}

                <DatePickerYear {...controlledYearDate} />

                {!openEditGeneral && !openEditCFOReport && (
                  <IconButton
                    title="Edit"
                    className="!w-8 !h-8 rounded-lg"
                    onClick={() => {
                      if (tabFs === "general") {
                        setOpenEditGeneral(true);
                      } else if (tabFs === "report_cfo") {
                        setOpenEditCFOReport(true);
                      }
                    }}
                  >
                    <div className="flex items-center gap-1">
                      <img src={EditIcon} alt="addIcon" className="w-3 h-3" />
                    </div>
                  </IconButton>
                )}
              </Box>
            )}
          </div>
          <div className="bg-white shadow-sm rounded-xl border-2 border-gray-7">
            {tabFs === "esg" && <ESGChart_dashboard />}
            {tabFs === "general" && (
              <GeneralForm
                disabled={!openEditGeneral}
                onClose={() => setOpenEditGeneral(false)}
                selectedFactSheetYear={yearDate}
              />
            )}
            {tabFs === "report_cfo" && (
              <ReportCFOForm
                disabled={!openEditCFOReport}
                onClose={() => setOpenEditCFOReport(false)}
                selectedFactSheetYear={yearDate}
              />
            )}

            {/* dialog upload fact sheet */}
            <DialogUploadFactSheet
              open={openDialogUploadFactSheet}
              onClose={() => setOpenDialogUploadFactSheet(false)}
            />
          </div>
        </Box>
      );
    default:
      return null;
  }
};
